import { getTranslation } from '../utils/languageUtils'
import { withNoSSR } from '../../components/withNoSSR'
import { useHasCookieConsent } from '../utils/hooks/useHasCookieConsent'

// ----------------------------------------------------------------------------------------------------

type Props = {
  children: React.ReactNode
}

const NoChildrenWithoutConsent = withNoSSR((props: Props) => {
  const { hasFunctionalConsent } = useHasCookieConsent()

  return (
    <>
      {hasFunctionalConsent ? (
        props.children
      ) : (
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.8)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 2,
            color: 'white',
            textAlign: 'center',
            padding: '20px',
            boxSizing: 'border-box',

            cursor: 'pointer',
          }}
          onClick={() => {
            // TODO: enable it...
            window.CookieManager?.showPreferenceCenter?.()
          }}
        >
          <div>
            <div style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: '10px' }}>
              {getTranslation('general.video.not.available')}
            </div>
            <div style={{ fontSize: '14px' }}>
              {getTranslation('general.video.cookies.required')}
            </div>

            <button type='button'>otevřít cookie centrum</button>
          </div>
        </div>
      )}
    </>
  )
})

export default NoChildrenWithoutConsent
